import React from 'react';
import styled from 'styled-components';
import axios from 'axios';

import NewsItem from "../components/News/NewsItem";
import Footer from "../components/shared/Footer";

class News extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      articles: [1, 2, 3]
    }
  }

  componentDidMount() {
    axios
      .get(`https://www.paralele.me/api/news/index.php?lang=${window.languageInt}`)
      .then(res => res.data)
      .then(data => {
        this.setState({ articles: data })
      })
  }

  render() {
    return (
      <>
        <div className="container">
          <NewsItemListing>
            {this.state.articles.map((item, i) => (
              <NewsItem
                key={i}
                itemId={i}
                delay={0.2}
                article={item}
              />
            )
            )}
          </NewsItemListing>
        </div>
        <Footer />
      </>
    )
  }
}

const NewsItemListing = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export default News;